import script from "./Invoices.vue?vue&type=script&setup=true&lang=js"
export * from "./Invoices.vue?vue&type=script&setup=true&lang=js"

import "./Invoices.vue?vue&type=style&index=0&id=38c53679&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c53679"]])

export default __exports__